export default __webpack_public_path__ + "static/Mohit-FullStack-JavaScript-766cd7f969a9ae2f20941c3bc4fd712e.pdf";